(function () {
    'use strict';
    angular
        .module('app')
        .directive('manualRelationships', manualRelationships);
    manualRelationships.$inject = ['$window'];
    function manualRelationships($window) {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
            },
            controller: 'manualRelationships',
            templateUrl: 'app/manualRelationships/manualRelationships.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();